import { displayToastError, http } from 'app';

export const getFields = async (
  businessArea: string,
  service: string
): Promise<any> => {
  try {
    const response = await http.get(
      '/:businessArea/:service/fields'
        .replace(':businessArea', businessArea)
        .replace(':service', service)
    );
    return response.data;
  } catch (error: any) {
    const errorMessage = error.response.data.message;
    displayToastError(String(errorMessage), 'Get Fields');
  }
};
